import customerNameItem from '../components/SelectOrder/CustomerNameItem.vue'
import enterOrderItem from '../components/SelectOrder/EnterOrderItem.vue'
import WithLabel from '@/components/DeptSelect/WithLabel.vue'

export default function () {
  const selectOrderFormList = [
    {
      el: 'select',
      elRender: WithLabel,
      itemConfig: {
        label: '所属部门',
        prop: 'deptId',
        required: true,
      },
      elConfig: {
        disabled: true,
        multiple: false,
        isAll: false,
      },
    },
    {
      el: 'select',
      itemConfig: {
        label: '客户名称',
        prop: 'customerId',
        ref: 'customerNameItem',
      },
      elConfig: {
        disabled: false,
        options: {
          label: 'customerName',
          value: 'id',
        },
        remoteMethod: this.customerNameRemoteMethod,
        events: {
          change: this.customerNameChange,
        },
        placeholder: '请输入',
      },
      elRender: customerNameItem,
    },
    {
      el: 'select',
      itemConfig: {
        label: '主订单ID',
        prop: 'entRentOrderId',
        ref: 'entRentOrderIdRef',
      },
      elConfig: {
        clearable: true,
        disabled: true,
        options: {
          label: 'id',
          value: 'id',
        },
        events: {
          change: (e) => {
            this.getDetails(e)
          },
          tipsClick: this.tipsClick,
        },
      },
      elRender: enterOrderItem,
    },
  ]
  const selectOrderFormModel = {}
  const selectOrderFormRules = {
    customerId: [
      { required: true, message: '请选择客户', trigger: 'change' },
    ],
    entRentOrderId: [
      { required: true, message: '请选择主订单', trigger: 'change' },
    ],
  }
  const selectOrderTextList = [
    {
      el: 'text',
      itemConfig: {
        label: '主订单ID',
        prop: 'id',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '客户类型',
        prop: 'customerType',
        value: '企业用户',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '客户名称',
        prop: 'customerName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '合同起止日期',
        prop: 'contractStartEndTime',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '租赁车辆数',
        prop: 'carTotalNum',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '已租车辆数',
        prop: 'rentedCarNum',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '主订单创建时间',
        prop: 'gmtCreate',
      },
    },
  ]
  const selectOrderTextModel = {
    id: '',
    companyName: '',
    customerName: '',
    contractStartEndTime: '',
    carTotalNum: '',
    rentedCarNum: '',
    gmtCreate: '',
  }


  return {
    selectOrderList: {
      selectOrderFormList,
      selectOrderTextList,
    },
    selectOrderModel: {
      selectOrderFormModel,
      selectOrderTextModel,
    },
    selectOrderRules: {
      selectOrderFormRules,
    },
  }
}
